<template>
  <div class="min-vh-100 d-flex flex-row align-items-center sign-bg">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol :md="5">
          <CCardGroup class="column">
            <CCard class="text-white right-bg  logo">
              <CCardBody
                class="d-flex align-items-center flex-column justify-content-center col-12"
              >
                <img
                  class="mb-4 col-6"
                  src="@/assets/images/logo-black.svg"
                  alt=""
                />
                <p>ESG問卷後台管理系統</p>
              </CCardBody>
            </CCard>
            <CCard class="p-4 login">
              <CCardBody>
                <CForm @submit.prevent="sign">
                  <h1>登入</h1>
                  <p class="text-medium-emphasis">登入您的帳戶</p>
                  <CInputGroup class="mb-3">
                    <CInputGroupText>
                      <CIcon icon="cil-user" />
                    </CInputGroupText>
                    <CFormInput
                      placeholder="使用者名稱"
                      autocomplete="username"
                      v-model="username"
                    />
                  </CInputGroup>
                  <CInputGroup class="mb-4">
                    <CInputGroupText>
                      <CIcon icon="cil-lock-locked" />
                    </CInputGroupText>
                    <CFormInput
                      type="password"
                      placeholder="使用者密碼"
                      autocomplete="current-password"
                      v-model="password"
                    />
                  </CInputGroup>
                  <CRow>
                    <CCol :xs="12" class="d-flex justify-content-end">
                      <CButton
                        type="submit"
                        color="primary"
                        class="px-4 text-white"
                      >
                        登入
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <MsgBox
      :show="showMsgBox"
      :errorMsg="errorMsg"
      @close="showMsgBox = false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import useInfo from '@/composables/useInfo'
import MsgBox from '@/components/MsgBox.vue'
import router from '@/router'

export default {
  name: 'Login',
  components: {
    MsgBox,
  },
  setup() {
    const { signIn, getUserInfo } = useInfo()
    const username = ref('')
    const password = ref('')
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const index = ref([
      {
        title: '來信系統',
        url: '/user-management/message-list',
      },
      {
        title: '權限管理',
        // url: '/analysis-questionnaire',
        url: '/user-management/user-group-list',
      },
      {
        title: '設置',
        url: '/user-management/user-enterprise-list',
      },
      {
        title: '問卷列表',
        url: '/analysis-questionnaire',
      },
      {
        title: '用戶填答結果',
        url: '/analysis-report/report-enterprise-list',
      },
      {
        title: 'JYG ESG 企業健檢',
        url: '/user-management/user-reply',
      },
      {
        title: '其他',
        url: '/user-management/user-enterprise-list',
      },
      {
        title: '用戶管理',
        url: '/user-management/user-enterprise-list',
      },
    ])
    const sign = async () => {
      const res = await signIn({
        username: username.value,
        password: password.value,
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
      } else {
        const user = await getUserInfo()
        const item = index.value.find(
          (e) => e.title === user.ret.info.index_router,
        )
        if (item) {
          router.push(item.url)
        } else {
          router.push('/user-management/user-enterprise-list')
        }
      }
    }
    return { username, password, sign, showMsgBox, errorMsg }
  },
}
</script>
<style lang="scss" scoped>
.sign-bg {
  background-image: url('~@/assets/images/sign.png');
  background-repeat: no-repeat;
  background-size: cover;
}
.right-bg {
  background: #fbfbfb;
  p {
    color: #4d4d4d;
    font-size: 28px;
  }
}
.column {
  flex-direction: column !important;
}
.logo {
  border-radius: 0;
  border-color: transparent;
  background-color: transparent;
  padding-bottom: 40px;
}
.login {
  // margin: 0 auto;
  border-radius: 4px;
  border-color: transparent;
}
</style>
